import React from 'react';
import { Grid, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/pjb/organisms/Meta';
import { Complete } from '@bizapp-lp/pjb/templates/Complete';
import { LinkCard } from '@bizapp-lp/pjb/molecules/LinkCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      marginBottom: '80px',
      '& .MuiTypography-body1': {
        margin: '0 auto 5px',
      },
    },
    gridItems: {
      display: 'flex',
      justifyContent: 'center',
      margin: theme.spacing(3, 0),
      [theme.breakpoints.up(370 + 2 * 16)]: {
        flexGrow: 0,
        minWidth: '370px',
      },
      [theme.breakpoints.up(768)]: {
        margin: theme.spacing(3, 3),
      },
    },
  }),
);

type CompleteState = {
  valid?: boolean;
};

export interface CompleteDocumentClaimProps {
  isAllowedDirectAccess?: boolean;
}

const title =
  'Project Board 資料ダウンロード | 社内外でのプロジェクトを円滑に進めるためのオンラインシェア型プロジェクト進捗管理サービス';
const description =
  'Project Boardは法人向けオンラインシェア型プロジェクト進捗管理サービスです。プロジェクト管理でよく利用されるガントチャート機能やかんばん機能を搭載し、チームや組織、外部ユーザーとのコラボレーションによる業務の効率化をサポートします。';

const CompleteDocumentClaim: React.FC<CompleteDocumentClaimProps> = ({
  isAllowedDirectAccess = false,
}) => {
  const classes = useStyles();
  const { state } = useLocation() as { state: CompleteState };
  const baseUrl = 'https://bizapp.worksap.co.jp/resource';

  const downloadCards = [
    {
      imgSrc: `${process.env.PUBLIC_URL}/images/dlfiles_thumbnail.png`,
      imgAlt: 'Project Board サービスご紹介資料',
      headingText: 'サービスご紹介資料',
      children: (
        <>
          <span>本サービスの特徴を、実例も交えてご紹介。</span>
          <span>無料トライアルも実施中です！</span>
        </>
      ),
      onClick: () => {
        const element = document.createElement('a');
        element.style.display = 'none';
        element.setAttribute('href', `${baseUrl}/pjb-dl0001`);
        element.setAttribute('target', `_blank`);
        element.setAttribute('download', '');
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      },
    },
  ];

  return isAllowedDirectAccess || state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1={'Project Board 資料ダウンロード'}
        heading2={'資料請求いただきありがとうございます'}
        description={
          <>
            <span>
              登録いただいたメールアドレスに資料をダウンロードできるリンクをお送りいたしました。
            </span>
            <span>以下より、ご希望の資料をクリックしてください。</span>
            <span>ダウンロードが開始されます。</span>
          </>
        }
      >
        <Grid container className={classes.gridContainer} justify="center">
          <Grid item className={classes.gridItems}>
            {downloadCards.map((props) => (
              <LinkCard iconVariant="download" {...props} key={props.imgAlt} />
            ))}
          </Grid>
        </Grid>
      </Complete>
    </>
  ) : (
    <Navigate to="/pjb/invalid" replace />
  );
};

export default CompleteDocumentClaim;
